export const LAB_WIKI_URL = "https://w.amazon.com/bin/view/ITAssetReclamation/Programs/LAB/";
export const TECH_REQUEST_URL = "https://techreq.harmony.a2z.com";
export const TEAM_PURCHASED_DEVICE_POLICY_URL = "https://policy.a2z.com/docs/34989/publication";
export const LAPTOP_SETUP_ARTICLE_URL = "https://my.it.a2z.com/articles/setup/laptop-setup";
export const HARDWARE_TICKET_URL =
  "https://t.corp.amazon.com/create/templates/ad768340-d5d0-4e6d-8ff9-43dda7281e71";
export const IT_PORTAL_URL = "https://my.it.a2z.com/";
export const SERVICE_ISSUE_TICKET_URL =
  "https://t.corp.amazon.com/create/options?category=IT%20Asset%20Management&type=Ordering%20Services&item=IT%20Shop%20HW";
